import React from "react";
import "./WhoWeEEPO.css";
import AboutImage from "../Image/FPOImage.png";

export default function WhoWeWEFPO() {
  return (
    <section className="fpo-excellence-section">
      <div className="fpo-excellence-container">

        {/* LEFT – IMAGE */}
        <div className="fpo-excellence-col fpo-excellence-left">
          <div className="fpo-excellence-image-wrapper">
            <img
              src={AboutImage}
              alt="Financial Process Outsourcing"
              className="fpo-excellence-img"
            />
          </div>
        </div>

        {/* RIGHT – CONTENT */}
        <div className="fpo-excellence-col fpo-excellence-right">
          <div className="fpo-excellence-content">

            <h2 className="fpo-excellence-title">
              Financial Process Outsourcing (FPO)
            </h2>

            <p className="fpo-excellence-text">
              The Densat Finance Methodology / FPO brings together professionalism
              and cost efficiency. Through the managed CFO model, clients gain
              access to experienced financial professionals while maximizing
              performance from their existing finance teams.
            </p>

            {/* SERVICES LIST */}
            <ul className="fpo-excellence-list">
              <li>
                <a href="https://jatin.biomaze.in/investment-advisory/" target="_blank" rel="noreferrer">
                  Investment Advisory
                </a>
              </li>
              <li>
                <a href="https://jatin.biomaze.in/kpo/" target="_blank" rel="noreferrer">
                  Knowledge Process Outsourcing (KPO)
                </a>
              </li>
              <li>
                <a href="https://jatin.biomaze.in/part-time-cfo-virtual-cfo/" target="_blank" rel="noreferrer">
                  Part-Time / Virtual CFO
                </a>
              </li>
              <li>
                <a href="https://jatin.biomaze.in/enterprise-risk-management/" target="_blank" rel="noreferrer">
                  Enterprise Risk Management
                </a>
              </li>
              <li>
                <a href="https://jatin.biomaze.in/asset-tagging/" target="_blank" rel="noreferrer">
                  Asset Tagging
                </a>
              </li>
              <li>
                <a href="https://jatin.biomaze.in/routine-fpo/" target="_blank" rel="noreferrer">
                  Routine FPO
                </a>
              </li>
            </ul>

          </div>
        </div>

      </div>
    </section>
  );
}
